module.exports = __webpack_public_path__ + "img/donation-after-2.cc937d87.png";